<template>
  <div class="compressed-content">
    <h3 class="page-question">Do you know your lowest HDL (“good”) cholesterol level from previous testing?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.lowestCholesterolLevel">
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.lowestCholesterolLevel" name="cholesterol"
                    :value=cholesterolLevel.Unknown>
        Don’t know or never tested
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.lowestCholesterolLevel" name="cholesterol"
                    :value=cholesterolLevel.VeryLow>
        Less than 40 mg/dL
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.lowestCholesterolLevel" name="cholesterol"
                    :value=cholesterolLevel.Low>
        Between 41-49 mg/dL
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.lowestCholesterolLevel" name="cholesterol"
                    :value=cholesterolLevel.High>
        50 mg/dL or higher
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import cholesterolLevel from "enums/cholesterol-level";

  export default {
    mixins: [formMixin],
    data() {
      return {
        cholesterolLevel: cholesterolLevel,
      };
    },

    validations: {
      lowestCholesterolLevel: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      lowestCholesterolLevel() { return this.survey.bloodBiochemistry.cholesterol.lowestCholesterolLevel }
    }
  };
</script>